<script>
  import { navigate } from '../router.js';
  export let directory;
  export let info;

  $: slug = directory.split('/').pop();

  function go(e) {
    e.preventDefault();
    navigate(`/portfolio/${slug}`);
  }
</script>

<a href={`/portfolio/${slug}`} on:click={go} class="card">
  <div class="card-img-wrapper">
    <img src={`${directory}/${info.images[0]}`} alt={info.title} class="card-img" />
  </div>
  <div class="card-title">{info.title}</div>
  <div class="card-year">{info.year}</div>
</a>

<style>
.card {
  background: transparent;
  width: 300px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
}
.card-img-wrapper {
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.card:hover .card-img {
  transform: scale(1.03);
}
.card-title {
  font-weight: 400;
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-top: 0.7rem;
}
.card-year {
  font-size: 0.7rem;
  letter-spacing: 0.1em;
  color: #888;
  margin-top: 0.2rem;
}
</style>
